// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".captcha_captcha__319QT {\n\n}\n\n.captcha_captchaText__5ka6F{\n    width: 55px;\n}\n\n.captcha_captchaImage__17wh0 {\n    margin-top: 5px;\n}\n.captcha_captchaImageButton__2pRNY {\n}\n", "",{"version":3,"sources":["webpack://src/components/captcha.module.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;AACA;AACA","sourcesContent":[".captcha {\n\n}\n\n.captchaText{\n    width: 55px;\n}\n\n.captchaImage {\n    margin-top: 5px;\n}\n.captchaImageButton {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"captcha": "captcha_captcha__319QT",
	"captchaText": "captcha_captchaText__5ka6F",
	"captchaImage": "captcha_captchaImage__17wh0",
	"captchaImageButton": "captcha_captchaImageButton__2pRNY"
};
export default ___CSS_LOADER_EXPORT___;
